import * as React from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={19}
        fill="none"
        cursor="pointer"
        {...props}
    >
        <path
            fill="#3A3A49"
            stroke="#F3F4F7"
            strokeWidth={0.5}
            d="M4.04 14.825a.994.994 0 0 0 .14-.011l3.943-.655a.235.235 0 0 0 .124-.062l9.935-9.405a.22.22 0 0 0 .069-.156.212.212 0 0 0-.069-.157L14.287.69a.239.239 0 0 0-.167-.064.239.239 0 0 0-.166.064l-9.935 9.406a.222.222 0 0 0-.066.117l-.691 3.732a.706.706 0 0 0 .023.357c.039.115.106.22.197.304.155.142.35.22.558.22Zm1.58-3.87 8.5-8.045 1.718 1.627-8.5 8.045-2.084.348.366-1.974Zm13.005 5.734H1.375c-.415 0-.75.317-.75.71v.799c0 .097.084.177.188.177h18.375c.103 0 .187-.08.187-.177v-.8c0-.392-.335-.71-.75-.71Z"
        />
    </svg>
)
export default SvgComponent
